import { render, staticRenderFns } from "./NegativacaoHome.vue?vue&type=template&id=529233db"
import script from "./NegativacaoHome.vue?vue&type=script&lang=js"
export * from "./NegativacaoHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports